import { Constants } from "./constants";

export class PageContent {
    
    public pageContent: Object ={} ;
    public type: String = 'pageContent';
    public _id: String = '';
    public owner: String = Constants.USER;
    public bookDocId:String ='';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/pageContent.ts